import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const ROAbout = () => {
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-blue-50 via-cyan-50 to-white relative overflow-hidden text-gray-900">
      {/* Water Wave Background */}
      <div className="absolute bottom-0 left-0 w-full opacity-10">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none" className="w-full h-64">
          <path fill="rgba(59, 130, 246, 0.3)" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-6 py-2 bg-blue-100 border-2 border-blue-400 rounded-full mb-6">
              <span className="text-blue-700 font-semibold font-mono text-sm tracking-wider">{t.roAboutBadge}</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-extrabold mb-6">
              <span className="text-gray-800">{t.roAboutTitle}</span>{' '}
              <span className="bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">{t.roAboutTitle2}</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full"></div>
          </div>

          {/* Content Cards */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-blue-100 transform hover:scale-105 transition-all duration-300 hover:border-blue-300">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{t.roAboutCard1Title}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t.roAboutCard1Text}
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-cyan-100 transform hover:scale-105 transition-all duration-300 hover:border-cyan-300">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{t.roAboutCard2Title}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t.roAboutCard2Text}
              </p>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-3xl p-8 md:p-12 text-white shadow-2xl">
            <div className="max-w-3xl mx-auto text-center">
              <div className="flex items-center justify-center mb-6">
                <svg className="w-8 h-8 mr-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
                </svg>
                <h3 className="text-3xl md:text-4xl font-bold">{t.roAboutBottomTitle}</h3>
              </div>
              <p className="text-lg text-blue-100 leading-relaxed">
                {t.roAboutBottomText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ROAbout;

